export default __webpack_public_path__ + "static/media/wealth2.b77aad7e.png";